// Chemical Section - Clean Design with Flip Cards
import { useState } from 'preact/hooks'
import ChemistryDiagram from '../../visualizations/ChemistryDiagram.jsx'
import { CHEMICAL, renderDefinition } from '../../../data/definitions.js'

export default function ChemicalSection({ cellData }) {
  const [flipped, setFlipped] = useState({})
  
  // Extract data from API (normalized data has flat structure)
  const chemistry = cellData?.chemical?.main_chemistry || 'N/A'
  const cathode = cellData?.chemical?.cathode || 'N/A'
  const anode = cellData?.chemical?.anode || 'N/A'
  const housing = cellData?.chemical?.housing || 'N/A'
  const anodeCC = cellData?.chemical?.anode_material_cc || 'N/A'
  const cathodeCC = cellData?.chemical?.cathode_material_cc || 'N/A'
  const technology = cellData?.technology || 'Li-Ion'
  const format = cellData?.mechanical?.format || 'N/A'
  
  // Determine ion type from technology (API returns "Li-Ion" or "Na-Ion")
  const ionLabel = technology?.includes('Na') ? 'Na⁺' : 'Li⁺'
  
  // Toggle flip state
  const toggleFlip = (id) => {
    setFlipped(prev => ({ ...prev, [id]: !prev[id] }))
  }
  
  return (
    <div className="chemical-section-new" data-tour="chemical-section">
      <div className="chemical-grid">
        {/* Chemistry Card with Diagram */}
        <div className={`key-spec-card flipcard ${flipped.chemistry ? 'flipped' : ''}`}>
          <div className="flipcard-inner">
            {/* Front */}
            <div className="flipcard-front">
              <button className="flip-btn" onClick={() => toggleFlip('chemistry')} title="Show info">?</button>
              <h3 className="column-title">Chemistry</h3>
              
              {/* Chemistry Diagram - Moved up */}
              <ChemistryDiagram 
                anode={anode}
                cathode={cathode}
                ionLabel={ionLabel}
              />
              
              {/* Material List */}
              <div className="spec-list">
                <div className="spec-row">
                  <span className="spec-label">Anode:</span>
                  <span className="spec-value">{anode}</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Cathode:</span>
                  <span className="spec-value">{cathode}</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Ion Type:</span>
                  <span className="spec-value">{ionLabel}</span>
                </div>
              </div>
            </div>
            
            {/* Back */}
            <div className="flipcard-back">
              <button className="flip-btn flip-btn-back" onClick={() => toggleFlip('chemistry')} title="Close">×</button>
              <h3 className="column-title">{CHEMICAL.chemistry.title}</h3>
              <div className="spec-detail-content">
                <p style="font-size: 12px; line-height: 1.6;">
                  {CHEMICAL.chemistry.text}
                </p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Materials Card */}
        <div className={`key-spec-card flipcard ${flipped.materials ? 'flipped' : ''}`}>
          <div className="flipcard-inner">
            {/* Front */}
            <div className="flipcard-front">
              <button className="flip-btn" onClick={() => toggleFlip('materials')} title="Show info">?</button>
              <h3 className="column-title">Materials</h3>
              <div className="spec-list">
                <div className="spec-row">
                  <span className="spec-label">Housing:</span>
                  <span className="spec-value">{housing}</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Current Collector Anode:</span>
                  <span className="spec-value">{anodeCC}</span>
                </div>
                <div className="spec-row">
                  <span className="spec-label">Current Collector Cathode:</span>
                  <span className="spec-value">{cathodeCC}</span>
                </div>
              </div>
            </div>
            
            {/* Back */}
            <div className="flipcard-back">
              <button className="flip-btn flip-btn-back" onClick={() => toggleFlip('materials')} title="Close">×</button>
              <h3 className="column-title">{CHEMICAL.materials.title}</h3>
              <div className="spec-detail-content">
                <p style="font-size: 12px; line-height: 1.6;">
                  {CHEMICAL.materials.text}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
